import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import { NessLabsS } from './module/NessLabsS.js';

/**
 * 캐릭터 데이터에서 매핑된 값을 추출하고 템플릿이 있는 경우 적용하여 반환합니다.
 *
 * @param {Object} params - 함수 파라미터 객체
 * @param {Object} params.user_custom_property_mapping_path - 사용자 정의 속성 매핑 경로 정보
 * @param {string|null} params.user_custom_property_mapping_path.id - 매핑 ID
 * @param {string|null} params.user_custom_property_mapping_path.template - 템플릿 문자열 (선택사항)
 * @param {string} params.user_custom_property_mapping_path.value - 추출할 값의 경로
 * @param {Object} params.character - 캐릭터 데이터 객체
 * @returns {string} 추출된 값 또는 템플릿이 적용된 문자열
 */
export function getCharacterReplacedValue({ user_custom_property_mapping_path, character }) {
  const path = user_custom_property_mapping_path?.value;
  if (path == null) return '';

  const template = user_custom_property_mapping_path?.template;
  const has_template = typeof template === 'string' && UtilS.isNotEmpty(template);

  let value = UtilS.pathFinder(character, path);

  // 비정상 값 처리: undefined, null, 빈 문자열, NaN 등
  const isInvalidValue =
    value === undefined ||
    value === null ||
    (typeof value === 'string' && value.trim() === '') ||
    (typeof value === 'number' && isNaN(value));

  if (isInvalidValue) {
    return '-';
  }

  switch (path) {
    case 'combat_power': {
      value = NessLabsS.formatCombatPowerPoint({ combat_power: value });
      break;
    }
    // 아바타 코디 아이템 이름들을 최대 20자 (영문 기준) 넘지 않도록 자르고 반환 (장패드 기획)
    case "avatar_items[{item_category: 'hair'}]->item_name":
    case "avatar_items[{item_category: 'face'}]->item_name":
    case "avatar_items[{item_category: 'top'}]->item_name":
    case "avatar_items[{item_category: 'bottom'}]->item_name":
    case "avatar_items[{item_category: 'shoes'}]->item_name":
    case "avatar_items[{item_category: 'weapon'}]->item_name": {
      value = NessLabsS.formatStringEllipsis({ string: value, max_length: 20 });
      break;
    }

    // 아바타 스탯 수치 3자리수마다 콤마 적용
    case "avatar_stats[{name: 'HP'}]->value":
    case "avatar_stats[{name: 'MP'}]->value":
    case "avatar_stats[{name: 'STR'}]->value":
    case "avatar_stats[{name: 'DEX'}]->value":
    case "avatar_stats[{name: 'INT'}]->value":
    case "avatar_stats[{name: 'LUK'}]->value": {
      value = NessLabsS.formatNumberWithCommas({ string: value, digitGroupSize: 3 });
      break;
    }
  }

  if (has_template && (typeof value === 'number' || typeof value === 'string')) {
    return template.replace(/\${3}/g, value + '');
  }
  return value;
}
